/**
 * Views where a hidden control bar could not be brought back.
 *
 * The bar returns on proximity, which is a `mousemove` listener on our own window. Where the pane is a
 * third-party iframe — ScriptSure's eRx — those events belong to the iframe's document and the parent
 * receives nothing at all, so there is no pointer gesture that reveals the bar. Keystrokes inside the
 * iframe are its own too, so there is no keyboard rescue either: a hidden bar is simply gone, and with it
 * the way back to the other views.
 *
 * The bar therefore stays out on these views regardless of the preference. Chrome that cannot be
 * recovered is worse than chrome that ignores a setting on one screen.
 */
const IFRAME_VIEW_SUFFIXES = ['/erx2'];

export const pointerCanReachBar = (pathname: string): boolean => {
  const route = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  return !IFRAME_VIEW_SUFFIXES.some((suffix) => route.endsWith(suffix));
};
